import 'style-loader!./error.component.scss';
import { Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-error',
    templateUrl: './error.component.html',
})

export class AppError implements OnInit{
    message = ""
    constructor(
        protected activetRoute: ActivatedRoute,
     ) { }

     ngOnInit(){
        this.activetRoute.queryParams.subscribe((params: Object) => {
            if(params.hasOwnProperty("message"))
                this.message=params["message"]
        })
     }

}


// WEBPACK FOOTER //
// ./src/app/theme/components/app-error/error.component.ts